module.exports = __webpack_public_path__ + "static/img/8.ca517f6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/5/1/eng/8.png
// module id = YdPd
// module chunks = 0